import axios from "axios";
import { del, get, post, patch,  put } from "./academic_years_api_helper";
import * as url from "./academic_years_url_helper";





// 
export const getAcademicYears = () => get(url.GET_ACADEMIC_YEARS);

export const getActiveAcademicYears = () => get(url.GET_ACTIVE_ACADEMIC_YEARS);


// Add feature
//export const addNewFeature = feature => post(url.ADD_NEW_ACTION, feature);
//export const addNewBranch = branch => post(url.ADD_NEW_BRANCH, JSON.stringify(branch));

export const addNewAcademicYear = academicYear => post(url.ADD_NEW_ACADEMIC_YEAR, academicYear);



// update feature
//export const updateFeature = feature => put(url.UPDATE_ACTION, feature);
export const updateAcademicYear = academicYear => patch(`${url.UPDATE_ACADEMIC_YEAR}/${academicYear.id}`,  academicYear);


// delete series categories
//export const deleteFeature = feature => del(url.DELETE_ACTION, { headers: { feature } });
export const deleteAcademicYear = academicYear => del(`${url.DELETE_ACADEMIC_YEAR}/${academicYear.id}`);







export {
  //getLoggedInUser,
  
  
};
